import type { ChangeEventHandler, ReactNode } from "react";
import className from "~/kernel/styling/className";

export type ChoiceProps = {
  id?: string;
  name?: string;
  children: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onSelect?: ChangeEventHandler<HTMLInputElement>;
  fullWidth?: boolean;
  padding?: "none" | "small" | "medium";
  value?: string;
};

export default function Choice(props: ChoiceProps) {
  const {
    id,
    name,
    fullWidth,
    padding = "medium",
    onSelect,
    children,
    disabled,
    value,
    selected,
  } = props;
  const state = determineState(props);
  return (
    <label
      htmlFor={id}
      className={className(
        "relative block rounded-md bg-white cursor-pointer",
        {
          none: "",
          small: "p-2",
          medium: "p-4",
        }[padding],
        { "w-full": fullWidth },
        "before:absolute before:inset-0 before:rounded-md",
        {
          disabled: "opacity-40 before:border before:border-slate-300",
          selected: "before:border-2 before:border before:border-secondary",
          idle: "before:border before:border-slate-300 before:hover:border-slate-600",
        }[state],
      )}
    >
      <input
        type="radio"
        id={id}
        name={name}
        className="absolute left-0 top-0 h-full w-full opacity-0"
        value={value}
        checked={selected}
        onChange={onSelect}
        disabled={disabled}
      />
      {children}
    </label>
  );
}

function determineState(props: ChoiceProps) {
  const { disabled, selected } = props;

  if (disabled) {
    return "disabled";
  }

  if (selected) {
    return "selected";
  }

  return "idle";
}
